export default __webpack_public_path__ + "static/media/plane2.b4a1e613.jpg";